import { ViewModel,View } from "binder"
import  { DebitTransferPaymentView } from "./debitTransferPayment-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { DebitCardSelectorViewModel } from "src/Sell/Payment/debitPayment/debitCardSelector-viewModel";
import { Converters } from "src/converters";
import { ServerConnection } from "src/server/serverConnection";

export class DebitTransferPaymentViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.debitCardSelectorViewModel = new DebitCardSelectorViewModel(<any>this)
        this.isFromRootDistrict = true;
    }
    GetDefaultView(): View <ViewModel> {
        return new DebitTransferPaymentView();
    }
    public getTypeId(): string {
        return "VM-BF657FFF-C5F1-48A5-A84F-3730C830F31A"
    }

    closePopup(result?: any) {
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set cardNo(v: string) { this._cardNo = v; } public get cardNo(): string { return this._cardNo;} private _cardNo: string;
    public set debitCardSelectorViewModel(v: DebitCardSelectorViewModel) { this._debitCardSelectorViewModel = v; } public get debitCardSelectorViewModel(): DebitCardSelectorViewModel { return this._debitCardSelectorViewModel;} private _debitCardSelectorViewModel: DebitCardSelectorViewModel;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isFromRootDistrict(v: boolean) { 
        this._isFromRootDistrict = v; 
        this.debitCardSelectorViewModel.refresh();
    } public get isFromRootDistrict(): boolean { return this._isFromRootDistrict;} private _isFromRootDistrict: boolean;
    
    public async createPayment(){
        let validationResult = this.validateInput();
        if(validationResult==''){
            try {
                this.isLoading = true;
                let converter = new Converters();
                let confirmationResult = await this.messageBoxSuccessYesNo(`آیا پرداخت با مبلغ ${this.amount} با کد پیگیری ${this.traceCode} بخ کارت با شماره ${this.cardNo} صحیح است؟`,'پرداخت نقدی');
                if(confirmationResult=='no'){
                    return;
                }
                let result = await ServerConnection.callServer('/Complex/PurchaseServices/CreateDebitTransferTransactionForPurchaseFactor',{
                    FactorId:this.invoiceId,
                    ReceiverCardNumber : this.cardNo,
                    Amount : this.amount,
                    TraceCode : this.traceCode,
                    PayerGatewayId : this.debitCardSelectorViewModel.selectedItem.id
                });
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess('ثبت پرداخت با موفقیت انجام شد.',"انجام عملیات")
                    this.closePopup();
                }else{
                    await this.messageBoxConfirmWarning('خطا در انجام عملیات',"خطا")
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در انجام عملیات',"خطا")
            } finally {
                this.isLoading = false;
            }
        }else{
            await this.messageBoxConfirmWarning(validationResult,"خطا")
        }
    }

    back(){
        this.closePopup();
    }
    private validateInput():string{
        let errors :string[]= []
        if(this.debitCardSelectorViewModel.selectedItem==null){
            errors.push('کارت مقصد مشخص نشده است.');
        }
        if(this.cardNo==''){
            errors.push('شماره کارت مشخص نشده است.');
        }
        if(this.cardNo.length !== 16){
            errors.push('شماره کارت باید 16 رقم باشد.');
        }
        if(this.traceCode==''){
            errors.push('کد پیگیری مشخص نشده است.');
        }
        if(this.amount<=0){
            errors.push('مبلغ به درستی تنظیم نشده است.');
        }
        return errors.join("\n");
    }
}
